import { ConnectedPriceBreakdown } from "../connectedComponents";

//TODO: remove component, after removing dependencies from other components
export const ConnectedPriceBreakdownDropdown = () => {
  return <ConnectedPriceBreakdown showFareDescription />;
};

//TODO: remove component, after removing dependencies from other components
export const ConnectedPriceBreakdownContent = () => {
  return <ConnectedPriceBreakdown />;
};
